import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { ProfileService } from '../../../services/profile.service';
import { FormsService } from '../../../services/forms.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';

@Component({
  selector: 'app-forms-view',
  templateUrl: './forms-view.component.html',
  styleUrls: ['./forms-view.component.scss']
})
export class FormsViewComponent implements OnInit {

    pagecode: string = "forms-view";
    module: string = "form";
    accessdenied: boolean = false;

    isLoading: boolean = true;

    code: string = "";
    isLinear = false;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;

    constructor(private _formBuilder: FormBuilder, private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private profileService: ProfileService, private formsService: FormsService,
        public authentication: AuthenticationService,
        public common: CommonService) {
        debugger;
        this.firstFormGroup = this._formBuilder.group({
            firstCtrl: ['', Validators.required],
        });
        this.secondFormGroup = this._formBuilder.group({
            secondCtrl: ['', Validators.required],
        });



    }



    form: any = { formSteps: [] };
    getFormByCode(code: any) {
        this.formsService.getFormByCode(code).subscribe(
            (res: any) => {
                if (res['formSteps'] === null)
                    res['formSteps'] = [];
                this.form = res;
                //console.log("this.formDetails", this.form);
            },
            (err) => {
                console.error("getFormByCodeErr", err);
            }
        );
    }

    btnDisabled: boolean = false;

    btnText: string = "Submit";
    //userData: any = this.authentication.userData;

    isRegistred: any = false;
    isUserRegisterd(formCode: any, userId: any) {
        this.formsService.isUserRegisterd(formCode, userId).subscribe(
            (res: any) => {
                this.isRegistred = res;
            },
            (err: any) => {
                console.error("err", err);
            }
        )
    }

    submittedForm: any = {
        formId: 0,
        userId: "",
        firstName: "",
        lastName: "",
        nationality: "",
        countryOfResidence: "",
        title: "",
        mobileCountryCode: "",
        mobilePhone: "",
        comment: "",
        gender: "",
        details: []
    }

    submit() {
        debugger;
        //console.log("this.form.details", this.form.details);
        this.submittedForm.formId = this.form.formId;
        if (this.formValidation()) {
            //for (var i = 0; i < this.files.length; i++) {
            //  this.submittedForm.details.push({
            //    "formId": this.form.formId,
            //    "id": this.files[i].formDetailId,
            //    "pardotKey": this.files[i].pardotKey,
            //    "title": this.files[i].title,
            //    "value": this.files[i].value
            //  });
            //}
            //console.log("this.submittedForm", this.submittedForm);
            this.btnDisabled = true;
            debugger;
            this.formsService.submitForm(this.submittedForm).subscribe(
                (res: any) => {
                    //console.log("res", res);
                    this.btnDisabled = false;
                    if (res) {
                        this.common.ShowMessage("info", "Your form is submitted successfully. Thank you", "");
                        this.router.navigate(['/home/news-feed']);
                    }
                },
                (err: any) => {
                    console.error("err", err);
                    this.btnDisabled = false;
                }
            )


        }
    }










    myControl = new FormControl();
    mobileLoginForm = new FormGroup({
        phone: new FormControl("", [Validators.required])
    });



    //nationalityList: any[] = this.common.countries;
    filteredNationality: any[] = [];
    selectedNationality: any;
    selectedGender: string = "";

    nationalityList: any[] = this.common.nationalities;
    countryOfResidenceList: any[] = this.common.countries;
   


    filterNationality(event: any) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.common.countries.length; i++) {
            let nat = this.common.countries[i];
            if (nat.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(nat);
            }
        }

        this.filteredNationality = filtered;
    }

    //countryOfResidenceList: any[] = this.common.countries;
    filteredCountry: any[] = [];
    selectedCountry: any;

    filterCountry(event: any) {
        //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
        let filtered: any[] = [];
        let query = event.query;
        for (let i = 0; i < this.common.countries.length; i++) {
            let cou = this.common.countries[i];
            if (cou.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
                filtered.push(cou);
            }
        }

        this.filteredCountry = filtered;
    }








    ngOnInit(): void {
        this.route.params.subscribe(val => {
            debugger;
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    debugger;
                    if (res.success && res.data) {

                        this.submittedForm.userId = this.authentication.userData.id;
                        this.submittedForm.firstName = this.authentication.userData.firstName;
                        this.submittedForm.lastName = this.authentication.userData.lastName;
                        this.submittedForm.nationality = this.authentication.userData.nationality;
                        this.submittedForm.countryOfResidence = this.authentication.userData.country;
                        this.submittedForm.title = this.authentication.userData.title;
                        this.submittedForm.mobileCountryCode = this.authentication.userData.mobileCountryCode;
                        this.submittedForm.mobilePhone = this.authentication.userData.mobilePhone;

                        if (this.authentication.userData.nationality) {
                            for (var i = 0; i < this.nationalityList.length; i++) {
                                this.nationalityList[i].selected = false;
                                if (this.nationalityList[i].name.toLowerCase() === this.authentication.userData.nationality.toLowerCase()) {
                                    this.selectedNationality = this.nationalityList[i];
                                    this.nationalityList[i].selected = true;
                                }
                            }
                        }
                        debugger;
                        if (this.authentication.userData.country) {
                            for (var i = 0; i < this.countryOfResidenceList.length; i++) {
                                this.countryOfResidenceList[i].selected = false;
                                if (this.countryOfResidenceList[i].name.toLowerCase() === this.authentication.userData.country.toLowerCase()) {
                                    this.selectedCountry = this.countryOfResidenceList[i];
                                    this.countryOfResidenceList[i].selected = true;
                                }
                            }
                        }
                        this.mobileLoginForm.setValue({ "phone": this.authentication.userData.mobilePhone });

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        let map: any = this.route.paramMap;
                        this.code = map.destination._value.code;

                        this.isUserRegisterd(this.code, this.authentication._authentication.id);
                        this.getFormByCode(this.code);

                        window.scroll(0, 0);
                        //
                    }
                    else
                        this.accessdenied = true;
                    this.isLoading = false;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                    this.isLoading = false;
                }
            );
        });
    }

    formDrpChangeValue(evt: any, detail: any) {
        var value = evt.target.value;
        detail.value = value;
    }

    genderChangeValue(evt: any) {
        var value = evt.target.value;
        this.authentication.userData.gender = value;
        this.selectedGender = value;
    }
    nationalityChangeValue(evt: any) {
        var value = evt.target.value;
        this.selectedNationality = { name: value };
    }
    countryChangeValue(evt: any) {
        var value = evt.target.value;
        this.selectedCountry = { name: value };
    }
    formValidation() {

        if (this.authentication.userData.firstName === '' || this.authentication.userData.lastName === '') {
            this.common.ShowMessage('error', 'First name and last name are mandatory', '');
            return false;
        }
        else if (this.mobileLoginForm.value.phone == null) {
            this.common.ShowMessage('error', 'Mobile number is mandatory', '');
            return false;
        }
        else if (this.selectedCountry.name === '' || this.selectedNationality.name === '') {
            this.common.ShowMessage('error', 'Nationality and country of residence are mandatory', '');
            return false;
        }
        else if (this.authentication.userData.title === '') {
            this.common.ShowMessage('error', 'Job title is mandatory', '');
            return false;
        }


        this.authentication.userData.mobilePhone = this.mobileLoginForm.value.phone;
        this.authentication.userData.mobileCountryCode = '';
        this.authentication.userData.nationality = this.selectedNationality.name;
        this.authentication.userData.country = this.selectedCountry.name;

        this.submittedForm.firstName = this.authentication.userData.firstName;
        this.submittedForm.lastName = this.authentication.userData.lastName;
        this.submittedForm.nationality = this.selectedNationality.name;
        this.submittedForm.countryOfResidence = this.selectedCountry.name;
        this.submittedForm.title = this.authentication.userData.title;
        this.submittedForm.mobileCountryCode = '';
        this.submittedForm.mobilePhone = this.mobileLoginForm.value.phone;
        this.submittedForm.gender = this.selectedGender;


        for (var j = 0; j < this.form.formSteps.length; j++) {
            var details = this.form.formSteps[j].details;
            for (var i = 0; i < details.length; i++) {
                if (details[i].value === undefined && details[i].isMandatory && details[i].type != "file") {
                    this.common.ShowMessage('error', details[i].mandatoryMsg, '');
                    return false;
                }
                else if (details[i].value === null && details[i].isMandatory && details[i].type != "file") {
                    this.common.ShowMessage('error', details[i].mandatoryMsg, '');
                    return false;
                }
                else if (details[i].value === "" && details[i].isMandatory && details[i].type != "file") {
                    this.common.ShowMessage('error', details[i].mandatoryMsg, '');
                    return false;
                }
                //else if (details[i].type === "file" && details[i].isMandatory) {
                //  if (this.files.length === 0) {
                //    this.common.ShowMessage('error', details[i].mandatoryMsg, '');
                //    return false;
                //  }
                //}
                else {
                    this.submittedForm.details.push({
                        "formId": this.form.formSteps[j].formId,
                        "id": details[i].formDetailId,
                        "pardotKey": details[i].pardotKey,
                        "title": details[i].title,
                        "value": details[i].value
                    });
                }
            }
        }



        return true;
    }
}

